import type { FC } from 'react';
import { useRef } from 'react';

import { Printer } from 'lucide-react';
import { useReactToPrint } from 'react-to-print';

import { InvestigationReportTemplate } from '@features/investigations/components/modals/investigation-report/InvestigationReportTemplate';
import { GenericFullPageModal, ModalAction } from '@shared/components/ui/custom';
import { Help, OnapsisLogo } from '@shared/icons';

import type { Investigation } from '../../../api/files.types';

interface InvestigationReportModalProps {
  onClose: () => void;
  investigation: Investigation;
}

export const InvestigationReportModal: FC<InvestigationReportModalProps> = ({ onClose, investigation }) => {
  const componentRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: 'Investigation_Report',
  });

  return (
    <div className="p-4 flex justify-center items-center h-screen" data-testid="investigation-report-modal-root">
      <GenericFullPageModal
        open
        onClose={onClose}
        title="Investigation Report"
        titleIcon={<OnapsisLogo />}
        headerActions={
          <>
            <ModalAction icon={Printer} onClick={handlePrint} data-testid="investigation-report-print-action" />
            <ModalAction
              icon={Help}
              onClick={() => console.log('Open Help')}
              data-testid="investigation-report-help-action"
            />
          </>
        }
        data-testid="investigation-report-modal"
      >
        <InvestigationReportTemplate investigation={investigation} ref={componentRef} />
      </GenericFullPageModal>
    </div>
  );
};
